__turbopack_context__.v({
  "root": "p0OrjW_root",
});
